export const styles = {
    containerForm: {
        marginBottom: "20px",
    },
    formControl: {
        margin: 8, // theme.spacing(1) = 1 * 8 = 8
        width: "100%",
    },
    selectEmpty: {
        marginTop: 16, // theme.spacing(2) = 2 * 8 = 16
    },
    paper: {
        padding: 40, // theme.spacing(5) = 5 * 8 = 40
        margin: 16, // theme.spacing(2) = 2 * 8 = 16
        color: "rgba(0, 0, 0, 0.6)", // theme.palette.text.secondary
    },
    avatar: {
        margin: 8, // theme.spacing(1) = 1 * 8 = 8
        backgroundColor: "#6366f1", // theme.palette.secondary.main
    },
    form: {
        // Fix IE 11 issue.
        marginTop: 8, // theme.spacing(1) = 1 * 8 = 8
    },

    submit: {
        margin: "24px 0 16px", // theme.spacing(3, 0, 2) = "24px 0px 16px"
        backgroundImage: `linear-gradient(to right, #00d2ff 0%, #3a7bd5  51%, #00d2ff  100%)`,
        backgroundSize: "200% auto",
        display: "block",
        width: "100%",
    },

    chipContainer: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap" as const,
        listStyle: "none",
        padding: 4, // theme.spacing(0.5) = 0.5 * 8 = 4
        margin: 0,
    },
    chip: {
        margin: 4, // theme.spacing(0.5) = 0.5 * 8 = 4
    },
} as const;

export default styles;
